module.exports = __webpack_public_path__ + "90d3c30a7fe2366b2d2bdb0950e98fd3.svg";